<template><div></div></template>

<script setup lang="ts">
definePage({
  redirect: { name: '/admin/chat/reports' },
})
</script>
